import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./../../../styles/theme.scss']
})
export class AsideComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
